export { default as LawsuitMovementItem } from "./LawsuitMovimentItem";
